import { render, staticRenderFns } from "./FarmBasic.vue?vue&type=template&id=7825c534&"
import script from "./FarmBasic.vue?vue&type=script&lang=js&"
export * from "./FarmBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports